/**
 * Adapters Barrel Export
 * Provides clean abstraction layer for external SDKs
 *
 * Usage:
 * import { getOpenAIModel, isOpenAIAvailable } from "@/lib/adapters";
 * import { getAlgoliaClient, searchIndex } from "@/lib/adapters";
 * import { getSvixClient, sendWebhook } from "@/lib/adapters";
 */

// OpenAI Adapter
export {
  isOpenAIAvailable,
  getOpenAIModel,
  generateAIText,
  generateAIObject,
  withRetry,
  // Re-exports from ai-sdk
  generateObject,
  generateText,
  gateway,
} from "./openai";

// Algolia Adapter
export {
  isAlgoliaAvailable,
  getAlgoliaConfig,
  getAlgoliaClient,
  getAlgoliaLiteClient,
  searchIndex,
  indexObject,
  indexObjects,
  deleteObject,
  configureIndex,
  getPatientTimelineIndex,
  getPatientIdFromIndex,
} from "./algolia";

// Svix Adapter
export {
  isSvixAvailable,
  getSvixConfig,
  getSvixClient,
  sendWebhook,
  verifyWebhookSignature,
  createEndpoint,
  listEndpoints,
  WebhookVerificationError,
} from "./svix";
